import { useQuery } from '@tanstack/react-query';
import { diagramApi } from '../../../services/diagram';

/** Shares the complete diagram listing with the diagram pages and graph. */
export function useCompleteDiagrams(enabled = true) {
  return useQuery({
    queryKey: ['diagrams', 'list'],
    queryFn: () => diagramApi.listDiagrams(),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
